{
  "identities.messages.1010001": "Banye",
  "identities.messages.1010002": "Banye na {provider}",
  "identities.messages.1010003": "Biko kwado omume a site n'ịchọpụta na ọ bụ gị.",
  "identities.messages.1010004": "Biko mezue ihe ịma aka nke abụọ.",
  "identities.messages.1010005": "Nyochaa",
  "identities.messages.1010006": "Koodu nchọpụta",
  "identities.messages.1010007": "Koodu mweghachi ndabere",
  "identities.messages.1010008": "Gaa n'ihu na igodo ngwaike",
  "identities.messages.1010009": "Gaa n'ihu",
  "identities.messages.1010010": "Gaa n'ihu",
  "identities.messages.1010011": "Banye na igodo ngwaike",
  "identities.messages.1010012": "Kwadebe ngwaọrụ WebAuthn gị (dịka igodo nchekwa, ihe nyocha njirimara ahụ, ...) wee pịa gaa n'ihu.",
  "identities.messages.1010013": "Gaa n'ihu",
  "identities.messages.1010014": "E zigara koodu na adreesị ị nyere. Ọ bụrụ na ị nataghị ya, biko lelee nhazi adreesị ahụ wee gbalịa ọzọ.",
  "identities.messages.1010015": "Zipu koodu nbanye",
  "identities.messages.1010016": "Ị gbalịrị ịbanye na \"{duplicateIdentifier}\", mana email ahụ ejirila akaụntụ ọzọ. Banye na akaụntụ gị na otu n'ime nhọrọ ndị dị n'okpuru iji tinye akaụntụ gị \"{duplicateIdentifier}\" na \"{provider}\" dịka ụzọ ọzọ ịbanye.",
  "identities.messages.1010017": "Banye ma jikọọ",
  "identities.messages.1010018": "Kwado na {provider}",
  "identities.messages.1010019": "Rịọ koodu iji gaa n'ihu",
  "identities.messages.1010021": "Banye na passkey",
  "identities.messages.1010022": "Banye na okwuntughe",
  "identities.messages.1010023": "Zipu koodu na {address}",
  "identities.messages.1040001": "Debanye aha",
  "identities.messages.1040002": "Debanye aha na {provider}",
  "identities.messages.1040003": "Gaa n'ihu",
  "identities.messages.1040004": "Debanye aha na igodo nchekwa",
  "identities.messages.1040005": "E zigara koodu na adreesị ị nyere. Ọ bụrụ na ị nataghị ozi, lelee nhazi adreesị ahụ wee gbalịa ndebanye aha ọzọ.",
  "identities.messages.1040006": "Zipu koodu ndebanye aha",
  "identities.messages.1040007": "Debanye aha na passkey",
  "identities.messages.1040008": "Azụ",
  "identities.messages.1040009": "Biko họrọ nzere iji gosipụta onwe gị.",
  "identities.messages.1050001": "E chekwara mgbanwe gị!",
  "identities.messages.1050002": "Jikọọ {provider}",
  "identities.messages.1050003": "Kewapụ {provider}",
  "identities.messages.1050004": "Kewapụ Ngwa Nchọpụta TOTP",
  "identities.messages.1050005": "Koodu QR ngwa nchọpụta",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Kpughee koodu mweghachi ndabere",
  "identities.messages.1050008": "Mee ka ọ rụọ ọrụ",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Ndị a bụ koodu mweghachi ndabere gị. Biko chekwaa ha n'ebe dị nchebe!",
  "identities.messages.1050011": "Kwado koodu mweghachi ndabere",
  "identities.messages.1050012": "Tinye igodo nchekwa",
  "identities.messages.1050013": "Aha igodo nchekwa",
  "identities.messages.1050014": "E jiri nzuzo na {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Kwụsị usoro a",
  "identities.messages.1050017": "Nzuzo Nchọpụta",
  "identities.messages.1050018": "Wepu igodo nchekwa \"{display_name}\"",
  "identities.messages.1050019": "Tinye passkey",
  "identities.messages.1050020": "Wepu passkey \"{display_name}\"",
  "identities.messages.1060001": "Ị nwetaghachiri akaụntụ gị nke ọma. Biko gbanwee okwuntughe gị ma ọ bụ guzobe ụzọ nbanye ọzọ (dịka nbanye mmekọrịta) n'ime nkeji {privileged_session_expires_at_unix_until_minutes} na-abịa.",
  "identities.messages.1060002": "E zigara email nwere njikọ mweghachi na adreesị email ị nyere. Ọ bụrụ na ị nataghị email, lelee nhazi adreesị ahụ ma jide n'aka na ị na-eji adreesị ị debanyere aha.",
  "identities.messages.1060003": "E zigara email nwere koodu mweghachi na adreesị email ị nyere. Ọ bụrụ na ị nataghị email, lelee nhazi adreesị ahụ ma jide n'aka na ị na-eji adreesị ị debanyere aha.",
  "identities.messages.1060004": "E zigara koodu mweghachi na \"{masked_address}\". Ọ bụrụ na ị nataghị ya, lelee nhazi adreesị ahụ ma jide n'aka na ị na-eji adreesị ị debanyere aha.",
  "identities.messages.1060005": "Nwetaghachi ohere ịbanye akaụntụ gị site n'inye adreesị mweghachi gị n'uju.",
  "identities.messages.1060006": "Kedu ka ị chọrọ isi weghachi akaụntụ gị?",
  "identities.messages.1060007": "Azụ",
  "identities.messages.1070001": "Okwuntughe",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Chekwaa",
  "identities.messages.1070004": "Njirimara",
  "identities.messages.1070005": "Nyefee",
  "identities.messages.1070006": "Nyochaa koodu",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "Zigharịa koodu",
  "identities.messages.1070009": "Gaa n'ihu",
  "identities.messages.1070010": "Koodu mweghachi",
  "identities.messages.1070011": "Koodu nchọpụta",
  "identities.messages.1070012": "Koodu ndebanye aha",
  "identities.messages.1070013": "Koodu nbanye",
  "identities.messages.1070014": "Banye ma jikọọ nzere",
  "identities.messages.1070015": "Biko mezue ihe ịma aka captcha iji gaa n'ihu.",
  "identities.messages.1070016": "Adreesị mweghachi",
  "identities.messages.1070017": "Nọmba ekwentị",
  "identities.messages.1080001": "E zigara email nwere njikọ nchọpụta na adreesị email ị nyere. Ọ bụrụ na ị nataghị email, lelee nhazi adreesị ahụ ma jide n'aka na ị na-eji adreesị ị debanyere aha.",
  "identities.messages.1080002": "Ị chọpụtara adreesị email gị nke ọma.",
  "identities.messages.1080003": "E zigara email nwere koodu nchọpụta na adreesị email ị nyere. Ọ bụrụ na ị nataghị email, lelee nhazi adreesị ahụ ma jide n'aka na ị na-eji adreesị ị debanyere aha.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Biko tinye {property} wee gbalịa ọzọ.",
  "identities.messages.4000003": "ogologo ga-abụrịrị >= {min_length}, mana enwetara {actual_length}",
  "identities.messages.4000004": "adabaghị n'usoro \"{pattern}\"",
  "identities.messages.4000005": "Enweghị ike iji okwuntughe ahụ n'ihi {reason}.",
  "identities.messages.4000006": "Nzere e nyere adịghị mma, lelee njehie nhazi n'okwuntughe gị ma ọ bụ aha njirimara, adreesị email, ma ọ bụ nọmba ekwentị.",
  "identities.messages.4000007": "Akaụntụ nwere otu njirimara (email, ekwentị, aha njirimara, ...) dị ugbu a.",
  "identities.messages.4000008": "Koodu nchọpụta e nyere adịghị mma, biko gbalịa ọzọ.",
  "identities.messages.4000009": "Enweghị ike ịchọta njirimara nbanye ọ bụla. Ị chefuru ịtọ ha? Nke a nwekwara ike ịbụ n'ihi nhazi sava na-ezighi ezi.",
  "identities.messages.4000010": "Akaụntụ arụbeghị ọrụ. Ị chefuru inyocha adreesị email gị?",
  "identities.messages.4000011": "Ị nweghị ngwaọrụ TOTP edoziri.",
  "identities.messages.4000012": "E jirila koodu mweghachi ndabere a.",
  "identities.messages.4000013": "Ị nweghị ngwaọrụ WebAuthn edoziri.",
  "identities.messages.4000014": "Ị nweghị koodu mweghachi ndabere edoziri.",
  "identities.messages.4000015": "Akaụntụ a adịghị ma ọ bụ ọ nweghị igodo nchekwa edoziri.",
  "identities.messages.4000016": "Koodu mweghachi ndabere adịghị mma.",
  "identities.messages.4000017": "ogologo ga-abụrịrị <= {max_length}, mana enwetara {actual_length}",
  "identities.messages.4000018": "ga-abụrịrị >= {minimum} mana achọtara {actual}",
  "identities.messages.4000019": "ga-abụrịrị > {minimum} mana achọtara {actual}",
  "identities.messages.4000020": "ga-abụrịrị <= {maximum} mana achọtara {actual}",
  "identities.messages.4000021": "ga-abụrịrị < {maximum} mana achọtara {actual}",
  "identities.messages.4000022": "{actual} abụghị multipleOf {base}",
  "identities.messages.4000023": "ihe kacha nke {max_items} ka ekwere, mana achọtara ihe {actual_items}",
  "identities.messages.4000024": "ihe kacha nta nke {min_items} ka ekwere, mana achọtara ihe {actual_items}",
  "identities.messages.4000025": "ihe dị na ndeksi {index_a} na {index_b} bụ otu",
  "identities.messages.4000026": "a tụrụ anya {allowed_types_list}, mana enwetara {actual_type}",
  "identities.messages.4000027": "Akaụntụ nwere otu njirimara (email, ekwentị, aha njirimara, ...) dị ugbu a. Biko banye na akaụntụ gị dị adị iji jikọọ profaịlụ mmekọrịta gị.",
  "identities.messages.4000028": "Ị gbalịrị ịbanye na {credential_identifier_hint} nke akaụntụ ọzọ na-eji. Ị nwere ike ịbanye site na iji {available_credential_types_list}. Ị nwere ike ịbanye site na iji otu n'ime ndị na-enye nbanye mmekọrịta ndị a: {available_oidc_providers_list}.",
  "identities.messages.4000029": "ga-aha ka ọ bụrụ {expected}",
  "identities.messages.4000030": "const jebeghị",
  "identities.messages.4000031": "Enweghị ike iji okwuntughe ahụ n'ihi na ọ yiri njirimara ahụ nke ukwuu.",
  "identities.messages.4000032": "Okwuntughe ahụ ga-abụrịrị opekata mpe mkpụrụedemede {min_length}, mana enwetara {actual_length}.",
  "identities.messages.4000033": "Okwuntughe ahụ ga-abụrịrị opekata {max_length} mkpụrụedemede, mana enwetara {actual_length}.",
  "identities.messages.4000034": "Achọtala okwuntughe ahụ na mmebi data ma ekwesịghị iji ya ọzọ.",
  "identities.messages.4000035": "Akaụntụ a adịghị ma ọ bụ ọ habeghị nbanye na koodu.",
  "identities.messages.4000036": "Njirimara e nyere adabaghị njirimara ejikọtara na mmegharị a na mbụ.",
  "identities.messages.4000037": "Akaụntụ a adịghị ma ọ bụ ọ nweghị usoro nbanye haziri.",
  "identities.messages.4000038": "Nchọpụta Captcha jebeghị, biko gbalịa ọzọ.",
  "identities.messages.4010001": "Oge maka mmekọrịta ahụ agwụla. Biko, gbalịa ọzọ.",
  "identities.messages.4010002": "Enweghị ike ịchọta atụmatụ iji banye gị. Ị mejuru mpempe akwụkwọ ahụ nke ọma?",
  "identities.messages.4010003": "Enweghị ike ịchọta atụmatụ iji debanye gị aha. Ị mejuru mpempe akwụkwọ ahụ nke ọma?",
  "identities.messages.4010004": "Enweghị ike ịchọta atụmatụ iji melite ntọala gị. Ị mejuru mpempe akwụkwọ ahụ nke ọma?",
  "identities.messages.4010005": "Enweghị ike ịchọta atụmatụ iji weghachi akaụntụ gị. Ị mejuru mpempe akwụkwọ ahụ nke ọma?",
  "identities.messages.4010006": "Enweghị ike ịchọta atụmatụ iji nyochaa akaụntụ gị. Ị mejuru mpempe akwụkwọ ahụ nke ọma?",
  "identities.messages.4010007": "E mechara arịrịọ ahụ nke ọma ma enweghị ike ịgbalịa ọzọ.",
  "identities.messages.4010008": "Koodu nbanye adịghị mma ma ọ bụ ejirila ya. Biko gbalịa ọzọ.",
  "identities.messages.4010009": "Nzere ejikọtara adabaghị.",
  "identities.messages.4010010": "Adreesị ị tinyere adabaghị adreesị ọ bụla a maara n'ime akaụntụ dị ugbu a.",
  "identities.messages.4040001": "Oge maka mmekọrịta ahụ agwụla. Biko, gbalịa ọzọ.",
  "identities.messages.4040002": "E mechara arịrịọ ahụ nke ọma ma enweghị ike ịgbalịa ọzọ.",
  "identities.messages.4040003": "Koodu ndebanye aha adịghị mma ma ọ bụ ejirila ya. Biko gbalịa ọzọ.",
  "identities.messages.4050001": "Oge maka mmekọrịta ahụ agwụla. Biko, gbalịa ọzọ.",
  "identities.messages.4060001": "E mechara arịrịọ ahụ nke ọma ma enweghị ike ịgbalịa ọzọ.",
  "identities.messages.4060002": "Mmegharị mweghachi ruru ọnọdụ ọdịda ma ga-agbalịa ọzọ.",
  "identities.messages.4060004": "Token mweghachi adịghị mma ma ọ bụ ejirila ya. Biko gbalịakwa mmegharị ahụ.",
  "identities.messages.4060005": "Oge maka mmekọrịta ahụ agwụla. Biko, gbalịa ọzọ.",
  "identities.messages.4060006": "Koodu mweghachi adịghị mma ma ọ bụ ejirila ya. Biko gbalịa ọzọ.",
  "identities.messages.4070001": "Token nchọpụta adịghị mma ma ọ bụ ejirila ya. Biko gbalịakwa mmegharị ahụ.",
  "identities.messages.4070002": "E mechara arịrịọ ahụ nke ọma ma enweghị ike ịgbalịa ọzọ.",
  "identities.messages.4070003": "Mmegharị nchọpụta ruru ọnọdụ ọdịda ma ga-agbalịa ọzọ.",
  "identities.messages.4070005": "Oge maka mmekọrịta ahụ agwụla. Biko, gbalịa ọzọ.",
  "identities.messages.4070006": "Koodu nchọpụta adịghị mma ma ọ bụ ejirila ya. Biko gbalịa ọzọ.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "Pụọ",
  "login.registration-button": "Debanye aha",
  "login.registration-label": "Ị nweghị akaụntụ?",
  "login.title": "Banye",
  "login.subtitle": "Banye na {parts}",
  "login.title-aal2": "Nchọpụta ihe abụọ",
  "login.subtitle-aal2": "Họrọ ụzọ iji mezue nchọpụta ihe abụọ gị",
  "login.code.subtitle": "A ga-ezipu koodu nchọpụta site na email",
  "login.webauthn.subtitle": "Biko kwadebe ngwaọrụ WebAuthN gị",
  "login.totp.subtitle": "Biko tinye koodu sitere na Ngwa Nchọpụta gị",
  "login.lookup_secret.subtitle": "Biko tinye otu n'ime koodu mweghachi ndabere gị nwere mkpụrụọnụọgụgụ 8",
  "login.title-refresh": "Nyochaa ọzọ",
  "login.subtitle-refresh": "Kwado njirimara gị na {parts}",
  "login.2fa.go-back": "Ọ nweghị ihe na-arụ ọrụ?",
  "login.2fa.go-back.link": "Laghachi azụ",
  "login.2fa.method.go-back": "Họrọ usoro ọzọ",
  "recovery.title": "Weghachi akaụntụ gị",
  "recovery.subtitle": "Tinye njirimara ejikọtara na akaụntụ gị iji nweta koodu ohere otu oge",
  "registration.login-button": "Banye",
  "registration.login-label": "Ị nwelarị akaụntụ?",
  "registration.title": "Debanye akaụntụ",
  "registration.subtitle": "Debanye aha na {parts}",
  "settings.navigation-back-button": "Azụ",
  "settings.subtitle": "Melite ntọala akaụntụ gị",
  "settings.title": "Ntọala Akaụntụ",
  "settings.password.title": "Gbanwee Okwuntughe",
  "settings.password.description": "Gbanwee okwuntughe gị",
  "settings.profile.title": "Ntọala Profaịlụ",
  "settings.profile.description": "Melite ozi profaịlụ gị",
  "settings.webauthn.title": "Jikwaa Token Ngwaike",
  "settings.webauthn.description": "Jikwaa ntọala token ngwaike gị",
  "settings.messages.toast-title.success": "E melitere ntọala",
  "settings.messages.toast-title.error": "Enweghị ike imelite ntọala",
  "verification.title": "Nyochaa akaụntụ gị",
  "verification.subtitle": "Tinye adreesị email ejikọtara na akaụntụ gị iji nyochaa ya",
  "two-step.password.title": "Okwuntughe",
  "two-step.password.description": "Tinye okwuntughe ejikọtara na akaụntụ gị",
  "two-step.code.title": "Koodu email",
  "two-step.code.description": "A ga-ezipu koodu nchọpụta na email gị",
  "two-step.webauthn.title": "Igodo nchekwa",
  "two-step.webauthn.description": "Jiri igodo nchekwa gị nyochaa",
  "two-step.passkey.title": "Passkey (a tụrụ anya ya)",
  "two-step.passkey.description": "Jiri ngwaọrụ gị maka mkpịsịaka ma ọ bụ nnabata ihu",
  "two-step.passkey.description.error": "Enweghị ike ibu ọba akwụkwọ dị mkpa iji jiri Passkey gị. Biko gbalịa ọzọ mgbe e mesịrị.",
  "two-step.totp.title": "Jiri Ngwa Nchọpụta gị (TOTP)",
  "two-step.totp.description": "Jiri koodu otu oge nwere mkpụrụọnụọgụgụ 6 site na ngwa nchọpụta gị",
  "two-step.lookup_secret.title": "Koodu mweghachi ndabere",
  "two-step.lookup_secret.description": "Jiri otu n'ime koodu ndabere gị nwere mkpụrụọnụọgụgụ 8 iji nyochaa",
  "input.placeholder": "Tinye {placeholder} gị",
  "card.header.parts.oidc": "onye na-enye mmekọrịta",
  "card.header.parts.password.registration": "{identifierLabel} gị na okwuntughe",
  "card.header.parts.password.login": "{identifierLabel} na okwuntughe gị",
  "card.header.parts.code": "koodu otu oge",
  "card.header.parts.passkey": "Passkey",
  "card.header.parts.webauthn": "igodo nchekwa",
  "card.header.parts.totp": "ngwa nchọpụta gị",
  "card.header.parts.lookup_secret": "koodu mweghachi ndabere",
  "card.header.parts.identifier-first": "{identifierLabel} gị",
  "misc.or": "ma ọ bụ",
  "forms.label.forgot-password": "Chefuru Okwuntughe?",
  "forms.label.recover-account": "Weghachi Akaụntụ",
  "settings.totp.title": "Ngwa Nchọpụta",
  "settings.totp.description": "Tinye Ngwa Nchọpụta TOTP na akaụntụ gị iji melite nchekwa akaụntụ gị. Ngwa Nchọpụta na-ewu ewu bụ LastPass na Google Authenticator",
  "settings.totp.info.not-linked": "Iji mee ka ọ rụọ ọrụ, nyochaa koodu QR na ngwa nchọpụta gị wee tinye koodu ahụ.",
  "settings.totp.info.linked": "Ugbu a ị nwere ngwa nchọpụta ejikọtara.",
  "settings.lookup_secret.title": "Koodu Mweghachi Ndabere (ihe abụọ)",
  "settings.lookup_secret.description": "Koodu mweghachi bụ ndabere echekwara maka 2FA, na-enye gị ohere ịnwetaghachi ohere ịbanye akaụntụ gị ma ọ bụrụ na ị tụfuo ngwaọrụ 2FA gị.",
  "settings.oidc.title": "Akaụntụ ejikọtara",
  "settings.oidc.description": "Jikọọ onye na-enye nbanye mmekọrịta na akaụntụ gị.",
  "settings.oidc.info": "Akaụntụ ejikọtara site na ndị na-enye ndị a nwere ike iji banye na akaụntụ gị",
  "settings.webauthn.info": "A na-eji Token Ngwaike maka nchọpụta ihe abụọ ma ọ bụ dịka ihe mbụ na Passkey",
  "settings.passkey.title": "Jikwaa Passkey",
  "settings.passkey.description": "Jikwaa ntọala passkey gị",
  "settings.passkey.info": "Jikwaa ntọala passkey gị",
  "card.footer.select-another-method": "Họrọ usoro ọzọ",
  "account-linking.title": "Jikọọ akaụntụ",
  "property.password": "okwuntughe",
  "property.email": "email",
  "property.phone": "ekwentị",
  "property.username": "aha njirimara",
  "property.identifier": "njirimara",
  "property.code": "koodu",
  "property.recovery_address": "adreesị mweghachi",
  "consent.title": "Kwado {party}",
  "consent.subtitle": "Ngwa nke ọzọ chọrọ ịnweta ozi ejikọtara na akaụntụ gị {identifier}.",
  "consent.scope.openid.title": "Njirimara",
  "consent.scope.openid.description": "Na-enye ngwa ohere inyochaa njirimara gị. Nke a dị mkpa maka nchọpụta na ahụmahụ nbanye ntụkwasị obi.",
  "consent.scope.offline_access.title": "Ohere Na-adịghị Na Ntanetị",
  "consent.scope.offline_access.description": "Na-enye ngwa a ohere ime ka ị banye n'ime ọbụlagodi mgbe ị naghị eji ya eme ihe.",
  "consent.scope.profile.title": "Ozi Profaịlụ",
  "consent.scope.profile.description": "Na-enye ohere ịnweta nkọwa profaịlụ gị bụ isi, gụnyere aha njirimara gị, aha mbụ, na aha ikpeazụ.",
  "consent.scope.email.title": "Adreesị Email",
  "consent.scope.email.description": "Weghachite adreesị email gị na ọnọdụ nchọpụta ya.",
  "consent.scope.address.title": "Adreesị Anụ Ahụ",
  "consent.scope.address.description": "Nweta adreesị nzipu gị.",
  "consent.scope.phone.title": "Nọmba Ekwentị",
  "consent.scope.phone.description": "Weghachite nọmba ekwentị gị na ọnọdụ nchọpụta ya.",
  "error.title.what-happened": "Gịnị mere?",
  "error.title.what-can-i-do": "Gịnị ka m nwere ike ime?",
  "error.instructions": "Biko gbalịa ọzọ n'ime nkeji ole na ole ma ọ bụ kpọtụrụ onye na-arụ ọrụ weebụsaịtị.",
  "error.footer.text": "Mgbe ị na-akọ njehie a, biko tinye ozi ndị a:",
  "error.footer.copy": "Detuo",
  "error.action.go-back": "Laghachi azụ",
  "identities.messages.4000039": "Okwuntughe ọhụrụ ga-adị iche na okwuntughe ochie.",
  "identities.messages.4000040": "Tinye adreesị ozi-e ziri ezi",
  "identities.messages.4000041": "Tinye nọmba ekwentị ziri ezi",
  "captcha.error": "Nyocha nchekwa kụrụ afọ n'ala. Biko nwaa ọzọ mechaa. Ọ bụrụ na nsogbu ahụ anọgide, kpọtụrụ nkwado.",
  "identities.messages.5000002": "Enweghị ụzụ nnabata dị. Biko, kpọtụrụ onye na-ahụ maka usoro ahụ.",
  "identities.messages.4010011": "Akaụntụ a agbachi ọsọ. Biko, kpọtụrụ ndị na-enyere aka maka enyemaka.",
  "identities.messages.1070018": "Adịresi email ma ọ bụ nọmba ekwentị",
  "identities.messages.1080004": "Ozi ederede nwere koodu nnabata ezitere na nọmba ekwentị ị nyere. Ọ bụrụ na ị nwetabeghị ozi ederede, lelee otu ị deere nọmba ahụ ma hụ na ị na-eji nọmba ị debere aha na ya.",
  "identities.messages.1080005": "Ị nọchiri nke ọma na ọnụọgụgụ ekwentị gị dị mma.",
  "identities.messages.5000003": "Nzukọ gị chọrọ nkwenye SSO, mana enweghị onye na-enye ọrụ SSO ahọrọla. Biko, kpọtụrụ onye na-ahụ maka usoro ahụ.",
  "identities.messages.1010024": "Banye na ngwaọrụ ahụ.",
  "identities.messages.1010025": "E zigara koodu n'adres gị. Ọ bụrụ na ị natabeghị ya, biko nwaa ọzọ.",
  "identities.messages.4000042": "Enweghị ngwa DeviceAuthn ọ bụla ị tọrọ.",
  "identities.messages.4000043": "Nnweta weebụ a na-eji maka nbanye adịghị mma, biko gbalịa ọzọ.",
  "identities.messages.4000044": "Akaraaka DeviceAuthn e nyere adịghị mma.",
  "identities.messages.4050002": "Ị nwere ike gbanwee otu adresi n'otu oge. Biko, melite adresi ọ bụla n'otu n'otu."
}
